export default __webpack_public_path__ + "static/media/fruits.32179554.svg";